"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarProjectSwitcherComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const lodash_1 = __importDefault(require("lodash"));
const ProjectsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectsDataProvider");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const ProjectModalComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/ProjectModalComponent");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const TextTruncated_1 = require("src/configeek_assets/src/components/common/widget/TextTruncated");
const CurrentPageProvider_1 = require("src/configeek_assets/src/components/common/provider/CurrentPageProvider");
const ToolbarProjectSwitcherComponent = ({}) => {
    const isMounted = (0, isMounted_1.default)();
    const history = (0, react_router_dom_1.useHistory)();
    const projectsDataContext = (0, ProjectsDataProvider_1.useProjectsDataContext)();
    const { page } = (0, CurrentPageProvider_1.useCurrentPageContext)();
    const projectApiKeyInUrl = page.identifier === "project" ? page.projectApiKey : undefined;
    //create modal
    const [createProjectModalVisible, setCreateProjectModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onCreateProjectModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setCreateProjectModalVisible({ visible: false });
        }
    }, [isMounted]);
    const onClickCreateProject = (0, react_1.useCallback)(() => {
        setCreateProjectModalVisible({ visible: true, nonce: createProjectModalVisible.nonce + 1 });
    }, [createProjectModalVisible.nonce]);
    const [state, setState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), {
        createProjectInProgress: false,
        dropdownVisible: false
    });
    const hasProjects = projectsDataContext.hasProjects();
    if (!hasProjects) {
        return null;
    }
    const { inProgress, loaded } = projectsDataContext.projectsCumulativeInfo.status;
    const currentProjectData = projectsDataContext.getProject(projectApiKeyInUrl);
    let buttonLabel = "Select Project";
    let selectedProjectApiKey = undefined;
    if (currentProjectData) {
        selectedProjectApiKey = currentProjectData.view.project.projectApiKey;
        buttonLabel = currentProjectData.view.project.projectName;
    }
    const onClickMenu = async ({ key }) => {
        if (lodash_1.default.isEqual("create", key)) {
            setState({
                dropdownVisible: false
            });
            onClickCreateProject();
        }
        else {
            setState({
                dropdownVisible: false
            });
            const url = AppRouter_1.PathGenerator.project(key);
            history.push(url);
        }
    };
    const onVisibleChangeDropdown = (visible) => {
        setState({ dropdownVisible: visible });
    };
    const projects = projectsDataContext.getProjects();
    const items = [];
    if (!loaded && inProgress) {
        items.push({
            key: "spin",
            disabled: true,
            label: React.createElement(antd_1.Spin, null)
        });
    }
    lodash_1.default.each(projects, ({ view: projectParticipantView }) => {
        const projectApiKey = projectParticipantView.project.projectApiKey;
        const projectTitle = projectParticipantView.project.projectName;
        const isTheSame = lodash_1.default.isEqual(projectApiKey, selectedProjectApiKey);
        const projectTitleElement = React.createElement(TextTruncated_1.TextTruncated, { text: projectTitle, length: 60 });
        if (isTheSame) {
            items.push({
                key: projectApiKey,
                disabled: true,
                label: projectTitleElement
            });
        }
        else {
            items.push({
                key: projectApiKey,
                label: projectTitleElement
            });
        }
    });
    if (hasProjects) {
        items.push({
            type: "divider"
        });
    }
    items.push({
        key: "create",
        label: React.createElement(antd_1.Button, { type: "link", className: "ug-text ug-text-full-width", loading: state.createProjectInProgress, disabled: state.createProjectInProgress }, "Create Project")
    });
    const menu = React.createElement(antd_1.Menu, { items: items, onClick: onClickMenu });
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Dropdown, { overlay: menu, trigger: ["click"], placement: "bottomRight", onVisibleChange: onVisibleChangeDropdown, visible: state.dropdownVisible },
            React.createElement(antd_1.Button, { disabled: true, type: "link", className: "projectSwitcher" },
                React.createElement("span", { className: "projectSwitcherLabel" },
                    React.createElement(TextTruncated_1.TextTruncated, { text: buttonLabel, length: 60 })),
                " ",
                React.createElement(icons_1.DownOutlined, null))),
        React.createElement(ProjectModalComponent_1.ProjectModalComponent, { key: createProjectModalVisible.nonce, visible: createProjectModalVisible.visible, onDestroy: onCreateProjectModalDestroy, ctx: "projectSwitcher" }));
};
exports.ToolbarProjectSwitcherComponent = ToolbarProjectSwitcherComponent;
